
      import Tips from './tips.vue'
      import type { App, Plugin } from 'vue'

      export const TipsPlugin: Plugin = {
        install(app: App) {
          app.component('Tips', Tips)
        },
      }
      export { Tips }
      